<template>
  <main class="dashboard">
    <section class="dashboard-shell">
      <div class="dashboard-heading">
        <h1>Colorize Black &amp; White Photos</h1>
        <p>
          Upload an image, run analysis, and generate a colorized version from one
          place.
        </p>
      </div>
      <ImageAnalyzer @image-returned="onImageReturned" />
    </section>
  </main>
</template>

<script>
import ImageAnalyzer from './ImageAnalyzer.vue';

export default {
  name: 'DashboardPage',
  emits: ['image-returned'],
  components: {
    ImageAnalyzer
  },
  methods: {
    onImageReturned() {
      this.$emit('image-returned');
    }
  }
};
</script>

<style scoped>
.dashboard {
  background: radial-gradient(circle at top right, rgba(108, 70, 236, 0.22), transparent 45%), #05060d;
  //min-height: 100vh;
}

.dashboard-shell {
  margin: 0 auto;
  max-width: 1200px;
  padding: 104px 20px 40px;
}

.dashboard-heading {
  margin: 50px auto 20px;
  max-width: 900px;
  text-align: center;
}

.dashboard-heading h1 {
  color: #f5f6ff;
  font-size: clamp(1.8rem, 3.4vw, 2.8rem);
  margin: 0 0 10px;
}

.dashboard-heading p {
  color: rgba(245, 246, 255, 0.82);
  line-height: 1.6;
  margin: 0;
}

.eyebrow {
  color: #b6f65a;
  font-size: 0.78rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  margin: 0 0 10px;
  text-transform: uppercase;
}
</style>
